// The project's own Header of the help center (both /help-center and
// /vendor/help-center): it takes the place of aldoo-ra/HelpCenter/fragments/Header.jsx
// (aldoo-ra/HelpCenter/hc-render.jsx), so its colours are this site's to change.
import HCRender from "aldoo-ra/HelpCenter/hc-render"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { getHelpCenterContext, DEFAULT_CONTEXT } from "aldoo-ra/HelpCenter/context"

const Header = ({ searchState, onSearchResultSelect }) => {
  const Search = HCRender.getFragment("Search")
  const texts = TextBundle({ id: "help-center" })

  return (
    <div className="header-container w-full">
      <div className="relative w-full max-w-w2_xl md:h-[290px] rounded-[30px] md:rounded-[50px] bg-gradient-to-br from-secondary/50 to-primary_lt/40 border border-white/60 p-4 mt-6 md:mt-12 mx-auto">
        <div className="relative w-full h-full flex flex-col items-center justify-center z-20 mx-auto">
          <Typography
            variant="h1" 
            className="text-3xl text-text text-center mb-8"
          >
            {/* the context's own title when the bundle has one (header_title_vendor), else the help center's */}
            {(getHelpCenterContext() !== DEFAULT_CONTEXT && texts?.[`header_title_${getHelpCenterContext()}`]) || texts?.header_title || "How can we help you?"}
          </Typography>
          {Search && (
            <Search searchState={searchState} onResultSelect={onSearchResultSelect} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
